module.exports = __webpack_public_path__ + "static/media/ic_bills_grey.1f0b344d.svg";